import { useMemo } from 'react';

// styles
import { alpha, useTheme } from '@material-ui/core';

// The markup `react-mentions` stores for a mention: `@[Jane Doe](12)`.
const MENTION_MARKUP = /@\[(.+?)\](?:\(.+?\))/g;

interface Props {
  body?: string | null;
}
export default function MentionText({ body }: Props) {
  const theme = useTheme();

  return useMemo(() => {
    if (!body) return null;

    return (
      <>
        {body.split(MENTION_MARKUP).map((part, i) =>
          i % 2 === 1 ? (
            <span
              key={i}
              style={{
                color: theme.palette.secondary.main,
                backgroundColor: alpha(theme.palette.secondary.main, 0.1),
                borderRadius: 6,
              }}
            >
              @{part}
            </span>
          ) : (
            part
          )
        )}
      </>
    );
  }, [body, theme.palette.secondary.main]);
}
